module.exports = __webpack_public_path__ + "img/v2wallPaper1.0032222c.png";